import { useNetworkStatus } from '../hooks/useNetworkStatus';

export default function OfflineBanner() {
  const { online, pendingSyncs } = useNetworkStatus();
  if (online) return null;

  return (
    <div className="flex items-center gap-2 px-4 py-2 bg-surface text-ink-soft text-sm rounded-lg mx-4 mt-2">
      <span className="relative flex h-2.5 w-2.5">
        <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-streak opacity-75" />
        <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-streak" />
      </span>
      <span>You're offline. Showing saved data</span>
      {pendingSyncs > 0 && (
        <span className="ml-auto text-xs opacity-75">{pendingSyncs} pending</span>
      )}
    </div>
  );
}
